import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Alert, Button, Col, Form, Input, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { connect } from 'react-redux';
import { capitalizeFirstLetter } from '../../../../util/text';
import { dateFormat } from '../../../../util/date';

import { validVerificationRequest } from '../../AuthActions';
import { addError } from '../../../Error/ErrorActions';

import Chrono from '../../../../components/Time/Chrono';

function UserVerificationCheck({ dispatch, intl, identifier, onValidation, verification = null }) {
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleChangeCodePart = event => {
        event && event.preventDefault();
        const currentIndex = parseInt(event.target.name, 10);
        let value = '';
        if(event.target.value.length > 1) {
            value = event.target.value.replace(/\s/g, '').slice(0, 6);
        } else if(event.target.value) {
            value = code.substring(0, currentIndex) + event.target.value + code.substring(currentIndex + event.target.value.length);
        }
        setCode(value);
        document.getElementById(`auth-verification-code-input-${currentIndex + 1}`)?.focus();
    };

    const handleValid = event => {
        event && event.preventDefault();
        setIsLoading(true);
        validVerificationRequest(identifier, code).then(result => {
            setIsLoading(false);
            onValidation(result?.key && result);
            // result = { key: 'dervozeflkv345refler' }
        }).catch(err => {
            setIsLoading(false);
            dispatch(addError(err));
            // displayErrors(
            //     'warning',
            //     moment.utc(verification?.end).isBefore(moment.utc())
            //     ? intl.formatMessage({ id: 'userAuthVerificationDelayError', defaultMessage: 'The delay to verify your account is over!' })
            //     : intl.formatMessage({ id: 'userAuthVerificationCodeError', defaultMessage: 'The verification code provided is not correct! Please check your last verification code received.' }),
            // );
        });
    };

    useEffect(() => {
        setCode(code => code.replace(/\s/, '')); // Remove white space (due to display code by 3-digit)
        if(code.length === 6) {
            handleValid();
        }
    }, [code]);

    const renderStrategyInformation = () => {
        let defaultMessage = '';
        switch(verification?.strategy) {
            case 'phone':
                defaultMessage = 'You will receive a verification code by text message. Please check your phone';
                break;

            case 'email':
                defaultMessage = 'You will receive a verification code by email. Please check your mailbox';
                break;

            default:
        }
        return (
            <p>
                <strong><FormattedMessage id={`userAuthVerificationStrategy${capitalizeFirstLetter(verification?.strategy)}`} defaultMessage={defaultMessage} /></strong><br />
                {verification?.end && (
                    <Fragment>
                        <span className="d-none d-lg-inline-block h4 text-primary text-info">
                            <Chrono date={verification?.end} /><br />
                        </span>
                        <br />
                        <FormattedMessage id="userAuthVerificationEndDateAlert" defaultMessage="You have until {date} to verify your account!" values={{ date: `${dateFormat(verification?.end, null, Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone)} ${Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || ''}` }} />
                    </Fragment>
                )}
            </p>
        );
    };

    const renderCodeForm = () => {
        // <Input type="text" size="lg" bsSize="6" value={code} className="text-center" onChange={event => setCode(event.target.value)} />
        return (
            <Row>
                {new Array(6).fill(1).map((v, index) => (
                    <Col key={index} xs="2">
                        <Input size="lg" type="text" name={index} value={code.slice(index, index + 1)} id={`auth-verification-code-input-${index}`} className="text-center" style={{ fontSize: '3rem' }} onFocus={event => event.target.select()} onChange={handleChangeCodePart} />
                    </Col>
                ))}
            </Row>
        );
    };

    if(verification) {
        return (
            <Form onSubmit={handleValid} className="text-center">
                {renderStrategyInformation()}
                {renderCodeForm()}
                <Button color="success" block size="lg" className="mt-3" disabled={isLoading} onClick={handleValid}>{isLoading ? <FontAwesomeIcon icon="spinner" spin /> : <FontAwesomeIcon icon="check-circle" />} <FormattedMessage id="valid" defaultMessage="Valid" /></Button>
            </Form>
        );
    }
    return (
        <Alert color="warning" className="text-center">
            <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="userAuthVerificationMissingError" defaultMessage="No verification process is on progress... Please contact your administrator" />
        </Alert>
    );
}

UserVerificationCheck.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    identifier: PropTypes.string.isRequired,
    onValidation: PropTypes.func.isRequired,
    verification: PropTypes.object,
};

export default connect()(withIntl(UserVerificationCheck));
